import { ProductCounterKey, ProductKey } from '@app/domain/models/product-selection.model';
import { TpvBusinessUnit } from '@app/domain/models/tpv/business-unit.model';
import { TpvCompany } from '@app/domain/models/tpv/company-directory.model';

/** Listas de directorio que la tarjeta de TPV descarga para contar y el panel reusa (R46). */
export interface ProductCountsCacheLists {
  tpvCompanies: readonly TpvCompany[];
  tpvUnits: readonly TpvBusinessUnit[];
}

/** Tiempo de vida de cada entrada de la caché de conteos (R8). */
export const PRODUCT_COUNTS_CACHE_TTL_MS = 5 * 60 * 1000;

/**
 * Caché de los conteos de las tarjetas de `/products` (feature 152, R8–R10).
 *
 * POR CONTADOR, no por tarjeta: si el directorio de unidades falló, volver a la
 * pantalla vuelve a pedir SOLO ese y pinta al instante los que sí llegaron.
 *
 * Reglas del contrato que toda implementación cumple:
 * - solo se guardan ÉXITOS (un número); un fallo no se cachea (R9);
 * - vive solo en memoria de la pestaña (nunca storage, URL ni logs) y la vacía
 *   `LogoutService.forgetTabMemory()` (R10);
 * - una entrada caduca a los 5 minutos ⇒ `get` devuelve `null`.
 */
export abstract class ProductCountsCache {
  abstract get(product: ProductKey, counter: ProductCounterKey): number | null;
  abstract set(product: ProductKey, counter: ProductCounterKey, value: number): void;

  abstract getList<K extends keyof ProductCountsCacheLists>(key: K): ProductCountsCacheLists[K] | null;
  abstract setList<K extends keyof ProductCountsCacheLists>(key: K, list: ProductCountsCacheLists[K]): void;

  abstract clear(): void;
}
